const List = ({title, children}: {title: string, children: React.ReactNode}): JSX.Element => {
	return (
		<section className="how-to">
			<div className="how-to__container container">
				<h3>{title}</h3>
				<ul className="how-to__list">
					{children}
				</ul>
			</div>
		</section>
	);
};

export default List;